import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/public/config");
      setConfig(data);
      setError(false);
      document.title = `${data.platform_name} — Inscrição de modelos`;
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <ConfigContext.Provider value={{ config, error, reload: load }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
